import React from "react";
import { TableBody, TableRow, TableCell } from "@mui/material";
import { Renderer } from "../descriptors/common";

type ListBodyProps = {
    data: any[];
    header: string[];
    renderers?: Record<string, Renderer>;
};

export default class ListBody extends React.Component<ListBodyProps> {
    defaultRenderer(data: any) {
        return <span>{data}</span>;
    }

    getRendererObj() {
        let renderer: Record<string, Renderer> = {};
        this.props.header.forEach((key) => {
            renderer[key] = this.defaultRenderer;
            if (this.props.renderers !== undefined && this.props.renderers[key] !== undefined) {
                renderer[key] = this.props.renderers[key];
            }
        });
        return renderer;
    }

    render() {
        let data = [];
        const renderers = this.getRendererObj();
        this.props.data.forEach((row) => {
            let dataRow = [];
            this.props.header.forEach((key) => {
                dataRow.push(<TableCell key={key}>{renderers[key](key in row ? row[key] : null, row)}</TableCell>);
            });
            data.push(<TableRow key={row.id}>{dataRow}</TableRow>);
        });

        return <TableBody>{data}</TableBody>;
    }
}
